import { TJob } from './isJob';
import jobFieldNamesList from './jobFieldNamesList';

function jobFieldsNamesString(job: Pick<TJob, 'jobFields'>): string {
	return jobFieldNamesList(job).join(', ');
}

export default jobFieldsNamesString;
